// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"142ef2ba","81":"5e33df00","787":"8eece2b2"}[chunkId] + ".chunk.js";
};